/**
 * Normalize API error detail to a string for safe display in UI.
 * Backends (e.g. FastAPI) often return detail as an array of { type, loc, msg, ... }.
 */
export function getApiErrorMessage(err: any, fallback: string): string {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail.map((d: any) => (d?.msg != null ? String(d.msg) : JSON.stringify(d))).join(' ');
  }
  return err?.message || fallback;
}
